import { SimpleHttpClient } from '@utils/simple_http_client';
const api = new SimpleHttpClient();
export { api };
